// src/api/rtk.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const api = createApi({
  baseQuery: fetchBaseQuery({ 
    baseUrl: '/noop',
    prepareHeaders: (headers, { getState }) => {
      // Add any custom headers if needed
      return headers;
    },
  }),
  refetchOnFocus: true,
  refetchOnReconnect: true,
  keepUnusedDataFor: 60,
  tagTypes: ['CollectionCard','CollectionStats','ChecklistDetail','Set','SetItems','Sale','SaleCard'],
  endpoints: () => ({}),
  // Add error handling
  onQueryStarted: (arg, { queryFulfilled }) => {
    queryFulfilled.catch((error) => {
      // RTK Query error
    });
  },
});